import { calendarTimeslotRef } from './consts';

export default function (editor, opts = {}) {
  const { label, category } = opts;
  const bm = editor.BlockManager;
  const style = `
  <style>
  .${calendarTimeslotRef} {
    min-height: 50px;
    padding: 10px;
    font-family: Arial, Helvetica Neue, Helvetica, sans-serif;
    font-size: 14px;
    border: 1px solid #ced4da;
  }
  .${calendarTimeslotRef} h2 {
    font-weight: revert;
  }
  .${calendarTimeslotRef} a:not(.timeslot-link),a:hover:not(.timeslot-link) {
    color: revert !important;
  }
  .${calendarTimeslotRef} .fc .fc-button:disabled {
    cursor: not-allowed;
  }
  .${calendarTimeslotRef} .fc-day-disabled .fc-daygrid-day-frame {
    cursor: revert;
  }
  .${calendarTimeslotRef} .fc-liquid-hack .fc-daygrid-day-frame {
    cursor: pointer;
  }
  .${calendarTimeslotRef} .fc .fc-daygrid-day-events {
    display: none;
  }
  .${calendarTimeslotRef} .fc .fc-daygrid-day-top {
    min-height: 3em;
    justify-content: center;
    align-items: center;
  }
  .${calendarTimeslotRef} .fc .fc-toolbar-title {
    font-size: 1.45em;
  }
  </style>
`;
  bm.add(calendarTimeslotRef, {
    label: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="50" fill="currentColor" class="bi bi-calendar2-plus" viewBox="0 0 16 16">
      <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z"/>
      <path d="M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5zM8 8a.5.5 0 0 1 .5.5V10H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V11H6a.5.5 0 0 1 0-1h1.5V8.5A.5.5 0 0 1 8 8"/>
    </svg>

    <div class="gjs-block-label">${label}</div>`,
    category: category,
    content: `<div class="calendar ${calendarTimeslotRef} d-flex" data-gjs-type="${calendarTimeslotRef}" data-js="${calendarTimeslotRef}">
      <img src="https://drapcode-static.s3.amazonaws.com/img/calendar-timeslot.png" alt="Time Slot" data-gjs-custom-name="Time Slot Placeholder" data-gjs-droppable="false" data-gjs-draggable="false" data-gjs-removable="false" data-gjs-copyable="false" data-gjs-selectable="false" data-gjs-highlightable="false"/>
    </div>${style}`,
    render: ({ model, className }) => `
    <div class="${className}-label ${className}__drapcode-wrap">
    ${model.get('label')}
    </div>

    <span class="${className}__info no-doc">
      <a target="_blank" href="#" draggable="false">
        <i class="${className}__info-fa fa fa-info-circle" style="margin-left: 5px" title="Check how to use ${label}?"></i>
      </a>
    </span>
  `,
  });
}
